var map = {
	"./arrow-down.svg": 3273,
	"./bell-fill-white.svg": 8969,
	"./bell-outline-black.svg": 1616,
	"./calendar-outline-black.svg": 9432,
	"./close.svg": 5124,
	"./dashboard-fill-black.svg": 7119,
	"./dashboard-fill-gray.svg": 6963,
	"./dashboard-outline-black.svg": 6874,
	"./dashboard-outline.svg": 9518,
	"./dashboard.svg": 940,
	"./eye-slash.svg": 9849,
	"./eye.svg": 1542,
	"./inbox-black.svg": 9613,
	"./inbox.svg": 9789,
	"./lock.svg": 9231,
	"./logout-black.svg": 1654,
	"./logout.svg": 428,
	"./mail-black-notification.svg": 7350,
	"./mail-fill-black.svg": 9483,
	"./mail-outline-gray.svg": 5004,
	"./mail.svg": 8952,
	"./marker-message.svg": 6668,
	"./more-fill-black.svg": 2790,
	"./more-outline.svg": 3746,
	"./people-outline-black.svg": 5021,
	"./request-fill-black.svg": 4881,
	"./request-fill-white.svg": 1624,
	"./request-outline.svg": 1495
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 956;